module.exports = __webpack_public_path__ + "x.75aaf9dd.png";